import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const MenuLinkComponent = (props: any) => {
    let [menuEstaAberto, setMenuEstaAberto] = useState(false);

    const showSubMenu = (subMenuId: string) => {
        let element = document.getElementById(subMenuId);
        if (element == null) {
            return;
        }

        let estaAberto = !(element.style.display == 'block');
        element.style.display = estaAberto ? 'block' : 'none';
        setMenuEstaAberto(estaAberto);

        let iconUpDown = document.getElementById('i-' + subMenuId);
        if (iconUpDown == null) {
            return;
        }

        iconUpDown.className = estaAberto ? 'fa fa-angle-up fa-2x up-down-arrow' : 'fa fa-angle-down fa-2x up-down-arrow';
    }

    if (props.onClick != null) {
        return (
            <li className="menu-principal" key={props.id ?? 0}>
                <a href="#" onClick={() => props.onClick()}>
                    {props.iconClass == null ? <span className="fa-span"></span> : <i className={props.iconClass}></i>}
                    <span className="nav-text">
                        {props.title}
                    </span>
                </a>
            </li>
        );
    }
    else if (props.subMenuId == null) {
        return (
            <li>
                <NavLink to={{pathname: props.link }} state={{ url: props.url }} className={(({ isActive }) => isActive ? 'active-link ' + props.styleClass : props.styleClass)} onClick={props.customClick}>
                    {props.iconClass == null ? <span className="fa-span"></span> : <i className={props.iconClass}></i>}
                    <span className="nav-text">
                        {props.title}
                    </span>
                </NavLink>
            </li>
        )
    }

    return (
        <li className="menu-principal" key={props.id ?? 0}>
            <a href="#" onClick={() => showSubMenu(props.subMenuId)}>
                {props.iconClass == null ? <span className="fa-span"></span> : <i className={props.iconClass}></i>}
                <span className="nav-text">
                    {props.title}
                </span>

                <i id={'i-' + props.subMenuId} className="fa fa-angle-down fa-2x up-down-arrow"></i>
            </a>

            <ul id={props.subMenuId}>
                {props.children}
            </ul>
        </li>
    )
}

export default MenuLinkComponent;